import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/app/default_app.svg'


const _withScopeId = n => (_pushScopeId("data-v-4747e795"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "topBox" }
const _hoisted_4 = { class: "leftBox" }
const _hoisted_5 = { class: "logo" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  src: _imports_0,
  class: "logoStyle"
}
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "right" }
const _hoisted_10 = { class: "bottom" }

import { defineComponent, ref, computed } from "vue";
import { useStore } from "vuex";
import { convertSecondsToHoursMinutesSecond } from "@/views/screen/component/fomat";
import Tooltip from "@/components/common/tooltip.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'appItem',
  props: {
  item: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const store = useStore();

return (_ctx: any,_cache: any) => {
  const _component_a_progress = _resolveComponent("a-progress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (__props.item.logo_url)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: __props.item.logo_url,
                  class: "logoStyle"
                }, null, 8, _hoisted_6))
              : (_openBlock(), _createElementBlock("img", _hoisted_7))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(Tooltip, {
              content: __props.item.name
            }, null, 8, ["content"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(convertSecondsToHoursMinutesSecond)(__props.item.usage)), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_a_progress, {
          percent: __props.item.perc,
          showInfo: false,
          class: "whats",
          height: "4px"
        }, null, 8, ["percent"])
      ])
    ])
  ]))
}
}

})